import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { ArrowPathIcon } from '@heroicons/react/24/outline'
import ButtonComponent from 'components/common/ButtonComponent'
import { REASONS, SOURCES } from './format'

const fieldClass = 'mt-1 p-2 border rounded bg-white'

const Filters = ({ filters, tenants, loading, onChange, onRefresh }) => {
  const { t } = useTranslation()

  const handleChange = event => {
    const { name, type, checked, value } = event.target
    onChange({ [name]: type === 'checkbox' ? checked : value })
  }

  return (
    <div className='flex flex-wrap items-end gap-4 border border-gray-200 bg-gray-50 p-4 rounded-lg'>
      <label className='flex flex-col text-sm font-medium'>
        {t('system.scanRejections.filters.tenant')}
        <select name='farmId' value={filters.farmId} onChange={handleChange} className={fieldClass}>
          <option value=''>{t('system.scanRejections.filters.allTenants')}</option>
          {tenants.map(tenant => (
            <option key={tenant.farmId} value={tenant.farmId}>{tenant.farmName}</option>
          ))}
        </select>
      </label>
      <label className='flex flex-col text-sm font-medium'>
        {t('system.scanRejections.filters.dateFrom')}
        <input type='date' name='dateFrom' value={filters.dateFrom} max={filters.dateTo} onChange={handleChange} className={fieldClass} />
      </label>
      <label className='flex flex-col text-sm font-medium'>
        {t('system.scanRejections.filters.dateTo')}
        <input type='date' name='dateTo' value={filters.dateTo} min={filters.dateFrom} onChange={handleChange} className={fieldClass} />
      </label>
      <label className='flex flex-col text-sm font-medium'>
        {t('system.scanRejections.filters.source')}
        <select name='source' value={filters.source} onChange={handleChange} className={fieldClass}>
          <option value=''>{t('system.scanRejections.filters.all')}</option>
          {SOURCES.map(source => (
            <option key={source} value={source}>{t(`system.scanRejections.sources.${source}`)}</option>
          ))}
        </select>
      </label>
      <label className='flex flex-col text-sm font-medium'>
        {t('system.scanRejections.filters.reason')}
        <select name='reason' value={filters.reason} onChange={handleChange} className={fieldClass}>
          <option value=''>{t('system.scanRejections.filters.all')}</option>
          {REASONS.map(reason => (
            <option key={reason} value={reason}>{t(`system.scanRejections.reasons.${reason}`)}</option>
          ))}
        </select>
      </label>
      <label className='flex items-center gap-2 text-sm pb-2'>
        <input type='checkbox' name='includeRepeatReads' checked={filters.includeRepeatReads} onChange={handleChange} />
        {t('system.scanRejections.filters.includeRepeatReads')}
      </label>
      <div className='ml-auto'>
        <ButtonComponent onClick={onRefresh} disabled={loading}>
          <ArrowPathIcon className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`} />
          <span className='font-medium'>{t('system.scanRejections.filters.refresh')}</span>
        </ButtonComponent>
      </div>
    </div>
  )
}

Filters.propTypes = {
  filters: PropTypes.shape({
    farmId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dateFrom: PropTypes.string,
    dateTo: PropTypes.string,
    source: PropTypes.string,
    reason: PropTypes.string,
    includeRepeatReads: PropTypes.bool
  }).isRequired,
  tenants: PropTypes.arrayOf(PropTypes.shape({
    farmId: PropTypes.number,
    farmName: PropTypes.string
  })).isRequired,
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired
}

export default Filters
